<template><div class="row" v-if="!serviceTypeLoading">
  <div class="col-sm-6 col-12 px-05 mt-1" v-for="teamType in roles" :key="teamType"> 
    <div class="card text-center mb-1 h-150">
      <div class="card-body py-1 card-area">
        <div
          class="
            badge-circle badge-circle-lg badge-circle-light-primary
            mx-auto
            my-1
          "
        >
          <i class="bx bxs-cog font-medium-5"></i>
        </div>
        <div class="right col-auto text-center role-count-area">
          <div class="text-muted font-size-sm">
            {{teamType.name}}
          </div>
          <h4 class="mb-0 count">{{ teamType.count }}</h4>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row" v-else>
    <div class="col-12">
      <loading-box></loading-box>
    </div>
  </div>
</template>


<script>
import baseModule, {
  ERROR,
  SERVICE_TYPE,
  GET_SERVICE_TYPE,
  MODULE_NAME,
  SUCCESS,
  GET_SERVICE_TYPE_LOADING,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";
import LoadingBox from "@/assets/components/loader/LoadingBox";
const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ServiceTypesWidget",
  component:{
    LoadingBox
  },
  data (){
  
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    serviceTypeLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_SERVICE_TYPE_LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    roles() {
      return store.getters[_MODULE_NAME + "/" + SERVICE_TYPE];
    },
    getServiceType() {
      let serviceType = this.roles;
      if (!serviceType) return 0;
      return serviceType;
    },
    electric() {
      let electric = this.roles;
      if (!electric) return 0;
      return electric.filter((item) => item.team_type_id === 1);
    },
    manage() {
      let electric = this.roles;
      if (!electric) return 0;
      return electric.filter((item) => item.team_type_id ===4);
    },
    build() {
      let electric = this.roles;
      if (!electric) return 0;
      return electric.filter((item) => item.team_type_id === 3);
    },
    mechanic() {
      let electric = this.roles;
      if (!electric) return 0;
      return electric.filter((item) => item.team_type_id === 2);
    },
  },
  mounted() {
    this.filterResults();
  },
  methods: {
    filterResults() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_SERVICE_TYPE, {});
    },
  },
};
</script>

<style scoped>
.row > div > .card {
  height: 150px !important;
}
.card-area {
  padding: 0px !important;
}
.role-count-area {
  padding: 0px;
}
</style>